<template>
  <div>
    <spinner :show="isLoading" />
    <div :show="!isLoading">
      <div v-if="getFamiliesCount === 0">
        <strong>Your organization has not added any recipients to the system. Add recipients to the system using the form or file upload above.</strong>
      </div>
      <div v-else>
        <div v-if="allowPagination" class="pagination">
          <b-pagination
            v-if="getFamiliesCount > perPage"
            v-model="currentPage"
            :total-rows="getFamiliesCount"
            :per-page="perPage"
            aria-controls="family-table"
          ></b-pagination>
        </div>
        <b-table
          v-if="families"
          id="family-table"
          :items="families"
          :fields="fields"
          :per-page="perPage"
          :current-page="currentPage"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
        >
          <template v-slot:cell(isDuplicate)="data">
            <div v-if="isItemDuplicate(data.item)" class="table-duplicate--inner"></div>
          </template>
          <template v-slot:cell(info)="data">
            <a v-if="isItemDuplicate(data.item)" href="#" @click="onInfoClick(data.item, $event)"><i class="zmdi zmdi-alert-circle"></i></a>
          </template>
          <template v-if="allowDelete" v-slot:cell(remove)="data">
            <button class="btn-nobackground" @click="onDeleteClick(data.item, $event)"><i class="zmdi zmdi-delete"></i></button>
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import hasDuplicate from '../util/recipHasDuplicates';
import modalNames from '../util/modalNames';
import Spinner from './Spinner';

export default {
  name: 'FamilyTable',
  components: { Spinner, },
  props: {
    limit: {
      type: Number,
      default: 10
    },
    allowDelete: {
      type: Boolean,
      default: true
    },
    allowPagination: {
      type: Boolean,
      default: true
    },
    sortListBy: {
      type: String,
      default: 'lastName'
    },
    isSortDesc: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      sortBy: this.sortListBy,
      sortDesc: this.isSortDesc,
      perPage: this.limit,
      currentPage: 1,
      duplicateList: [],
      fields: [
        {
          key: 'isDuplicate',
          sortable: false,
          class: 'table-duplicate'
        },
        {
          key: 'createdDate',
          sortable: true,
          class: 'table-date'
        },
        {
          key: 'firstName',
          sortable: true
        },
        {
          key: 'lastName',
          sortable: true
        },
        {
          key: 'addressLine1',
          label: 'Address',
          sortable: false
        },
        {
          key: 'info',
          sortable: true,
          class: 'table-alert-icon'
        },
        {
          key: 'remove',
          sortable: false,
          class: 'table-remove-icon'
        }
      ],
    }
  },
  computed: {
    families() {
      return this.$store.getters.getRecipients.map((item) => {
        item.isDuplicate = hasDuplicate(item);
        return item;
      });
    },
    getFamiliesCount() {
      return this.$store.getters.getRecipients.length;
    },
    isLoading() {
      return this.$store.getters.getIsRecipientLoading;
    }
  },
  mounted() {
    this.$store.dispatch('listRecipients');
  },
  methods: {
    onInfoClick(item, event) {
      event.preventDefault();
      const payload = {
        main: item.id,
        duplicates: item.duplicates,
      };
      this.$store.dispatch('setDuplicateToResolve', payload);
      this.$bvModal.show(modalNames.DUPLICATE_MODAL);
    },
    onDeleteClick(recip, event) {
      event.preventDefault();
      this.$store.dispatch('setRecipToDelete', recip);
      this.$bvModal.show(modalNames.DELETE_RECIPIENT_CONFIRMATION_MODAL);
      //if we're going to be on a page that no longer exists, move us back
      if (Math.ceil((this.getFamiliesCount-1)/this.perPage) < this.currentPage) {
        this.currentPage -= 1;
        if (this.currentPage < 0) { this.currentPage = 1; }
      }
    },
    isItemDuplicate(item) {
      return item.duplicates ? item.duplicates.length : 0;
    }
  }
}
</script>
